module.exports = __webpack_public_path__ + "static/cortex-about-chyll-min-3fdbe87d950f98d4c204c47d593eb8f2.png";